// Text for the live-vs-ledger comparison the server computes.
export function balanceStatus(balance) {
  if (!balance || balance.live_balance === null || balance.live_balance === undefined) {
    return { tone: 'muted', text: 'No live balance yet' };
  }
  if (!balance.mismatch) return { tone: 'ok', text: 'Matches the bank' };
  const d = Number(balance.difference);
  const sign = d > 0 ? '+' : '-';
  return { tone: 'warn', text: `Off by ${sign}$${Math.abs(d).toFixed(2)} (bank minus eloNest)` };
}
